import { createContext, useContext } from "react";
import type { ContentBundle, Explainer, FastProfileQuestion } from "../types";

export type ContentStatus = "loading" | "ready" | "error";

export interface ContentContextValue {
  status: ContentStatus;
  bundle: ContentBundle | null;
  /** Looks up one explainer by key. Returns undefined for an unresolved or
   * missing key — callers must render no affordance in that case, never an
   * empty disclosure. */
  explainer: (key: string | undefined) => Explainer | undefined;
  questionsByField: Record<string, FastProfileQuestion>;
  retry: () => void;
}

export const ContentContext = createContext<ContentContextValue | null>(null);

export function useContent(): ContentContextValue {
  const context = useContext(ContentContext);
  if (!context) {
    throw new Error("useContent must be used within a ContentProvider");
  }
  return context;
}
